import * as R from 'runtypes';

export const ApiFiatTransferPurposeCode = R.Record({
  id: R.Number,
  code: R.String,
  name: R.String,
  description: R.String,
}).asReadonly();

export type FiatTransferPurposeCode = R.Static<typeof ApiFiatTransferPurposeCode>;
